import React, {useEffect, useState} from "react";
import styles from "./Details.module.css";
import {IProduct} from "../../../../services/model/Product";
import {useLocation} from "react-router-dom";
import Navbar from "../../../layout/navigation/v2/navBar";
import FooterXsci from "../../../layout/footer/footer-xsci";
import Variant from "./variant/variant";
import Instructions from "../../../../v2/components/ordering-instructions/Instructions";

const Details: React.FC = () => {
    const location = useLocation();
    const state = location.state as { product: IProduct } | null;
    const product = state?.product;

    const [mainImage, setMainImage] = useState(product?.imageUrl[0]);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0); // jump to top immediately
    }, []);

    const changeImage = (index: number, src: string) => {
        setMainImage(src);
        setActiveIndex(index);
    };

    // Fallback if direct navigation without product
    if (!product) {
        return (
            <div className="container mt-5" style={{backgroundColor: "black"}}>
                <div className="alert alert-warning">
                    Product not found. <a href="/">Go back to products</a>
                </div>
            </div>
        );
    }

    const message = `Bonjour, je souhaite avoir plus d'informations concernant le: ${product.name}\n\n`;
    const smsHref = `sms:5145459049?body=${encodeURIComponent(message)}`;

    return (
        <div style={{backgroundColor: "black"}}>
            <Navbar/>
            <div className={`container mt-5 text-start ${styles.detailsContainer}`}>

                {/* --- MOBILE HEADER: Shows only on mobile (d-block d-md-none) --- */}
                <div className="d-block d-md-none mb-4" style={{color: "white"}}>
                    <h2 className="mb-2">{product.name}</h2>
                    <div className="h4 mt-3">${product.price.toFixed(2)}</div>
                </div>

                <div className="row">
                    {/* LEFT COLUMN: Product Images */}
                    <div className="col-md-6 mb-4">
                        <div className={`${styles.imageWrapper} mb-3`}>
                            <img
                                src={mainImage}
                                alt={product.name}
                                className={styles.productImage}
                            />
                        </div>

                        <div className="d-flex gap-3 px-3">
                            {product.imageUrl?.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt={`Thumbnail ${index + 1}`}
                                    className={`rounded ${styles.thumbnail} ${
                                        activeIndex === index ? styles.active : ""
                                    }`}
                                    onClick={() => changeImage(index, img)}
                                />
                            ))}
                        </div>
                    </div>

                    {/* RIGHT COLUMN: Product Details */}
                    <div className="col-md-6" style={{color: "white"}}>

                        {/* --- DESKTOP HEADER: Hidden on mobile (d-none d-md-block) --- */}
                        <div className="d-none d-md-block">
                            <h2 className="mb-3">{product.name}</h2>
                            <div className="mb-3">
                                <span className="h4 me-2">${product.price.toFixed(2)}</span>
                            </div>
                        </div>

                        <p className="mb-4">
                            {product.description || "Experience premium quality with this product."}
                        </p>

                        {/* VARIANTS */}
                        {product?.variants && product.variants.length > 0 && (
                            <>
                                <h4 style={{marginBottom: "15px"}}>Options</h4>
                            </>
                        )}
                        <div className="mb-3" style={{backgroundColor: '#000', color: '#fff', padding: '20px'}}>
                            {product.variants?.map((variant, index) => (
                                <Variant variant={variant} key={index}/>
                            ))}
                        </div>

                        <a
                            href={smsHref}
                            className={`btn btn-primary btn-lg mb-3 me-2 ${styles.orderButton}`}
                        >
                            Textez nous pour plus d'info
                        </a>
                        <a href="https://www.instagram.com/vice.aquatics/" target="_blank"
                           rel="noopener noreferrer"
                            className={`btn btn-primary btn-lg mb-3 me-2 ${styles.instaButton}`}
                        >
                            Écrivez-nous sur Instagram
                        </a>
                    </div>
                    <Instructions/>
                </div>
            </div>
            <FooterXsci/>
        </div>
    );
};

export default Details;